
import { Injectable }       from '@angular/core';
import { Headers }   from '@angular/http';
import { InscricaoAluno } from './inscricao-aluno';
import { Validacao } from '../validacao/validacao';
import { Observable }       from 'rxjs';
import { ServiceUtil } from '../util/service.util';
import { PagerComponent } from '../paginator/pager.component';
import { Orcamento} from '../orcamento/orcamento';
import { Periodo } from './periodo';
import { HttpService } from 'ems-oauth2-client';
import { map, catchError, publishReplay, refCount } from 'rxjs/operators';


@Injectable()
export class InscricaoAlunoService extends ServiceUtil  {

    private headers:Headers = new Headers({'Content-Type': 'application/json'});
    private url = '/editaldpg/inscricao/aluno';

    constructor(private http: HttpService, private pagerComponent: PagerComponent) { super(); }

    // altera ou inclui InscricaoAluno
    public update(inscricaoAluno : InscricaoAluno): Observable<InscricaoAluno> {
        let body = JSON.stringify(inscricaoAluno);
        if(!inscricaoAluno.id){
          return this.http.post(this.url, body)
            .pipe(map(response =>  response),
             catchError(this.handleError),
             publishReplay(1),
             refCount());
        }else{
          return this.http.put(this.url + "/" + inscricaoAluno.id , body)
            .pipe(map(response => response),
             catchError(this.handleError),
             publishReplay(1),
             refCount());
        }
    }

        // altera ou inclui InscricaoAluno
    public updateSimples(inscricaoAluno : InscricaoAluno): Observable<InscricaoAluno> {
      let body = JSON.stringify(inscricaoAluno);
      return this.http.put(this.url + "/" + inscricaoAluno.id + "/update_simples" , body)
        .pipe(map(response =>  response),
         catchError(this.handleError),
         publishReplay(1),
         refCount());
    }

    // deleta InscricaoAluno
    public deletar(inscricaoAluno: InscricaoAluno): Observable<InscricaoAluno> {
      return this.http.delete(this.url + "/" + inscricaoAluno.id)
        .pipe(map(response => response),
         catchError(this.handleError),
         publishReplay(1),
         refCount());
    }

    // lista todos (sem filtro)
    public listar(): Observable<InscricaoAluno[]> {
      return this.http.get(this.url)
            .pipe(map(response =>  response),
             catchError(this.handleError),
             publishReplay(1),
             refCount());
    }

    public inicializa(alunoRa: String): Observable<InscricaoAluno> {
      return this.http.get(this.url + "/" + alunoRa + "/inicializa")
            .pipe(map(response =>  response),
             catchError(this.handleError),
             publishReplay(1),
             refCount());
    }


    public recuperaPeriodoAtualInscricao(): Observable<InscricaoAluno> {
      return this.http.get(this.url + "/periodoAtual")
            .pipe(map(response =>  response),
             catchError(this.handleError),
             publishReplay(1),
             refCount());
    }

    // recupera por id
    public getId(id : number): Observable<InscricaoAluno> {
        return this.http.get(this.url + "/" + id)
                  .pipe(map(response => response),
                   catchError(this.handleError),
                   publishReplay(1),
                   refCount());
    }

    public getPeriodoAtual(): Observable<Periodo[]> {
        return this.http.get("/academico/periodo/pos/atual")
                  .pipe(map(response => {
                    return  response;
                   }),
                   catchError(this.handleError),
                   publishReplay(1),
                   refCount());
    }




    // filtra
    public filtrar(filtro : InscricaoAluno): Observable<InscricaoAluno[]>{
      let colocaVirgula = false;
      let novaUrl = "{" ;
      if(filtro.alunoRa){
       novaUrl += "alunoRa:\"" + filtro.alunoRa + "\"";
       colocaVirgula = true;
      }
      if(filtro.id){
        if(colocaVirgula){
          novaUrl += ", ";
        }
       novaUrl += "id:\"" + filtro.id + "\"";
       colocaVirgula = true;
      }

      if(filtro.periodo){
        if(colocaVirgula){
          novaUrl += ", ";
        }
       novaUrl += "periodo:\"" + filtro.periodo + "\"";
       colocaVirgula = true;
      }

      if(filtro.alunoNome){
        if(colocaVirgula){
          novaUrl += ", ";
        }
       novaUrl += "alunoNome__contains:\"" + filtro.alunoNome + "\"";
       colocaVirgula = true;
      }
      if(filtro.situacao){
        if(colocaVirgula){
          novaUrl += ", ";
        }
       novaUrl += "situacao:\"" + filtro.situacao + "\"";
       colocaVirgula = true;
      }

      if(filtro.alunoNivel){
        if(colocaVirgula){
          novaUrl += ", ";
        }
         novaUrl += "alunoNivel:\"" + filtro.alunoNivel + "\"";
         colocaVirgula = true;

      }

      novaUrl +=  "}";

      let urlModify = this.pagerComponent.formatarUrl(this.url,novaUrl,1000,0);
      urlModify +=  "&sort=pontuacao desc, quantidadeSS desc, quantidadeMS desc, quantidadeMM desc, quantidadeCC desc";

      return this.http.get(urlModify)
              .pipe(map(response =>{
                  var result = response;
                  PagerComponent.allItems = result;
                  return  response;
              }),
               catchError(this.handleError),
               publishReplay(1),
               refCount());
    }

    public validar(validacao: Validacao){
      let body = JSON.stringify(validacao);

      return this.http.put(this.url + "/" + validacao.codigoInscricaoAluno + "/validacao" , body)
        .pipe(map(response =>  response),
         catchError(this.handleError),
         publishReplay(1),
         refCount());
    }

    // filtra
    public filtrarValidacao(filtro : Validacao): Observable<Validacao[]>{
        let colocaVirgula = false;
        let novaUrl = "{" ;

        if(filtro.tipoValidacao){
         novaUrl += "tipoValidacao:\"" + filtro.tipoValidacao + "\"";
         colocaVirgula = true;
        }

        if(filtro.id){
          if(colocaVirgula){
            novaUrl += ", ";
          }
         novaUrl += "id:\"" + filtro.id + "\"";
         colocaVirgula = true;
        }

        if(filtro.codigoInscricaoAluno){
          if(colocaVirgula){
            novaUrl += ", ";
          }
         novaUrl += "codigoInscricaoAluno:\"" + filtro.codigoInscricaoAluno + "\"";
         colocaVirgula = true;
        }

        novaUrl +=  "}";


        let urlModify = this.pagerComponent.formatarUrl(this.url + "/validacoes" , novaUrl, 100 , 0);
        //urlModify +=  "&sort=pontuacao desc";
        urlModify +=  "&sort=id asc"; // atenção, não mudar esse asc, pq na tela de validacao a ordem importa!

        return this.http.get(urlModify)
              .pipe(map(response =>{
                  var result = response;
                  return  response;
              }),
               catchError(this.handleError),
               publishReplay(1),
               refCount());
    }


    public recuperaOrcamento(semestreAno : number): Observable<Orcamento>{
      return this.http.get(this.url +  "/orcamento/" + semestreAno)
              .pipe(map(response =>{
                  var result = response;
                  return  response;
              }),
               catchError(this.handleError),
               publishReplay(1),
               refCount());
    }

}
